export const handleDateInputRestriction = (e) => {
    const keyCode = e.key ? e.key.charCodeAt(0) : e.keyCode ?? e.which;
    if (
        keyCode === 8 || // back
        keyCode === 9 || //tab
        keyCode === 65 || //left arrow
        keyCode === 66 || //Backspace
        keyCode === 68 || //delete
        keyCode === 69 || //end
        keyCode === 72 || //home
        keyCode === 70 || //f5
        keyCode === 84 // Tab
    ) {
        return;
    }

    const isValidChar =
        (keyCode >= 48 && keyCode <= 57) || keyCode === 191 || keyCode === 47;

    if (!isValidChar) {
        e.preventDefault();
        return;
    }
    const value = e.target.value;
    const length = value.length;

    const isSlashKey = keyCode === 47 || keyCode === 191;

    if (length === 0 && isSlashKey) {
        e.preventDefault();
        return;
    }

    if (length == 1) {
        const day = isSlashKey
            ? "0" + e.target.value
            : e.target.value + String.fromCharCode(keyCode);

        if (parseInt(day) > 31) {
            e.preventDefault();
            return;
        }

        const newValue = day + "/";
        e.target.value = newValue;
        e.preventDefault();
        return;
    }
    if (length === 4) {
        const parts = value.split("/");
        const day = parts[0];
        const month = isSlashKey
            ? "0" + parts[1]
            : parts[1] + String.fromCharCode(keyCode);

        if (parseInt(month, 10) > 12) {
            e.preventDefault();
            return;
        }

        const newValue = "" + day + "/" + month + "/";

        e.target.value = newValue;
        e.preventDefault();
        return;
    }
    if (length === 2 || length === 5) {
        if (isSlashKey) return;
        e.target.value = e.target.value + "/" + String.fromCharCode(keyCode);
        e.preventDefault();
    }

    if (isSlashKey) e.preventDefault();
};
